<template>
  <svg
    width="13"
    height="24"
    viewBox="0 0 13 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="12.3536"
      y1="0.353553"
      x2="0.353554"
      y2="12.3536"
      stroke="#D5C7BE"
    />
    <line
      y1="-0.5"
      x2="16.9706"
      y2="-0.5"
      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 12 24)"
      stroke="#D5C7BE"
    />
  </svg>
</template>

<script>
export default {
  name: 'HomeLeftArrow'
}
</script>
